import { trackAdjust } from "@otto-ec/apps-api/thirdpartytracking";
import { eventQBus } from "../../types/EventQBus";

function getArticleNumberArrayAsString() {
  /*                                                                                */
  const articleSelector = ".product:not(.featured-article):not(.spa)";
  const products: NodeList = document.querySelectorAll(articleSelector);
  const COUNT_PRODUCTS = 4;
  const loopCount: number = products.length < COUNT_PRODUCTS ? products.length : COUNT_PRODUCTS;
  const articleNumbers: Array<string> = [];

  for (let i = 0; i < loopCount; i++) {
    const articleNumber: string = (products[i] as HTMLElement).dataset.articleNumber || "";
    if (articleNumber !== "") {
      articleNumbers.push(articleNumber);
    }
  }

  return JSON.stringify(articleNumbers);
}

function getEventName(android: string, ios: string) {
  return {
    eventName: {
      android: android,
      ios: ios,
    },
  };
}

function tileListAdjustEvent(sitePath: string, android: string, ios: string) {
  const eventName = getEventName(android, ios);
  const productTracking = {
    partnerParameters: {
      articleids: getArticleNumberArrayAsString(),
      contentType: "product",
      sitePath: sitePath,
    },
  };

  return { ...eventName, ...productTracking };
}

function contentPageAdjustEvent(sitePath: string) {
  const eventName = getEventName("cyv1b3", "pcv0sa");
  const productTracking = {
    partnerParameters: {
      sitePath: sitePath,
    },
  };

  return { ...eventName, ...productTracking };
}

function defaultAdjustEvent() {
  const eventName = getEventName("tap3xe", "duht9i");
  const productTracking = {
    partnerParameters: {
      articleids: "[]",
      contentType: "product",
    },
  };

  return { ...eventName, ...productTracking };
}

export function trackAdjustEventForPage(sitePath: string) {
  const avContent: HTMLElement | null = document.getElementById("avContent");
  if (avContent) {
    const pageType: string = avContent.dataset.pt || "";
    switch (pageType) {
      case "Produktliste":
        trackAdjust(tileListAdjustEvent(sitePath, "tap3xe", "duht9i"));
        break;
      case "Suchergebnisseite":
        trackAdjust(tileListAdjustEvent(sitePath, "9ldrbv", "kxrhs8"));
        break;
      default:
        trackAdjust(contentPageAdjustEvent(sitePath));
    }
  } else {
    trackAdjust(defaultAdjustEvent());
  }
}

let reptileAppsTrackingInitialized = false;

/**
 *
 */
export function registerAppAdjustTracking(sitePath?: string) {
  /*                                   */
  if (reptileAppsTrackingInitialized) {
    return;
  }
  reptileAppsTrackingInitialized = true;

  /*                                                */
  trackAdjustEventForPage(sitePath || window.location.href);

  /*                                                        */
  eventQBus.on("ftfind.tilelist.loaded", () => trackAdjustEventForPage(sitePath || window.location.href));
}
